<template>
  <v-content>
    <!-- Desktop -->
    <section v-if="$vuetify.breakpoint.mdAndUp" style="margin-top: 64px;">
      <!-- Player Selector -->
      <v-layout row wrap class="mx-3">
        <v-flex xs12 class="my-3">
          <v-card>
            <v-card-title>
              <v-select
                max-height="400"
                :items="$store.getters.getDevices"
                :label="selPlayerLang()"
                item-text="name"
                item-value="item"
                v-model="selectedPlayer"
                @input="updateSelectedSchedule()"
                hide-details
                class="pr-3"
                autocomplete
              ></v-select>
              <v-select
                max-height="400"
                hide-details
                :label="selYearLang()"
                class="pr-3"
                v-model="selectedYear"
                @input="updateYear()"
                v-bind:items="yearArray()"
              ></v-select>
              <v-select
                max-height="400"
                hide-details
                :label="selWeekLang()"
                class="pr-3"
                v-model="week"
                @input="updateWeek()"
                v-bind:items="weekArray()"
                autocomplete
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="warning"
                dark
                @click="addClassDesktop=false"
                :disabled="!addClassDesktop || $store.getters.getSelectedScheduleId == null "
              >
                <v-flex v-lang.modify></v-flex>&nbsp;&nbsp;
                <v-icon>create</v-icon>
              </v-btn>
              <v-btn round color="success" dark @click="saveSchedule()" :disabled="addClassDesktop">
                <v-flex v-lang.save></v-flex>&nbsp;&nbsp;
                <v-icon>done</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Program Selector -->
      <v-layout v-if="!addClassDesktop" row wrap align-center class="mx-3">
        <v-flex xs12 sm8 class="pr-3">
          <v-card>
            <v-card-title>
              <v-select
                max-height="400"
                hide-details
                :label="selClassLang()"
                v-model="classToSchedule"
                :items="getAvailableClasses"
                item-text="name"
                item-value="id"
                class="pr-3"
                autocomplete
              ></v-select>
              <v-select
                max-height="400"
                hide-details
                :label="selHoursLang()"
                class="pr-3"
                v-model="startHour"
                v-bind:items="hoursArray()"
                autocomplete
              ></v-select>
              <v-select
                max-height="400"
                hide-details
                :label="selMinutesLang()"
                class="pr-3"
                v-model="startMinute"
                v-bind:items="minutesArray()"
                autocomplete
              ></v-select>
              <v-spacer></v-spacer>
              <v-subheader class="text-xs-center cell">
                <v-flex xs8 v-lang.clickOnDate class="cell"></v-flex>
              </v-subheader>
            </v-card-title>
          </v-card>
        </v-flex>
        <!-- Week Buttons -->
        <v-flex xs12 sm4>
          <v-card>
            <v-card-title>
              <v-layout row wrap align-center justify-center>
                <a v-lang.weekControl class="font-subheading-2 white--text"></a>
                <v-spacer></v-spacer>
                <v-btn round color="primary" dark slot="activator" @click="copyWeek()">
                  <v-flex v-lang.copy></v-flex>&nbsp;&nbsp;
                  <v-icon>content_copy</v-icon>
                </v-btn>
                <span v-if="show">
                  <v-flex v-lang.copiedWeek></v-flex>
                  <v-flex text-xs-center>{{this.weekToCopy}}</v-flex>
                </span>
                <v-btn round color="warning" :disabled="weekToCopy === 0" dark @click="pasteWeek()">
                  <v-flex v-lang.paste></v-flex>&nbsp;&nbsp;
                  <v-icon>content_paste</v-icon>
                </v-btn>
                <v-btn round color="error" dark @click="clearWeek()">
                  <v-flex v-lang.clear></v-flex>&nbsp;&nbsp;
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Calendar -->
      <v-layout class="mx-3 mb-5 pb-3">
        <v-flex xs12>
          <v-layout class="font-number-2" row wrap>
            <!-- Month -->
            <v-flex xs12 sm3 class="text-xs-left">{{getMonth}} {{selectedYear}}</v-flex>
            <v-flex sm6></v-flex>
            <!-- Week Selector -->
            <v-flex xs12 sm3>
              <v-layout row wrap>
                <v-flex xs4></v-flex>
                <v-flex xs1>
                  <v-icon
                    class="nextWeekArr icon-transform-1"
                    @click="prevWeek()"
                  >keyboard_arrow_left</v-icon>
                </v-flex>
                <v-flex v-lang.week xs4 text-xs-right @dblclick="gotoCurrentWeek()"></v-flex>
                <v-flex xs2 text-xs-center @dblclick="gotoCurrentWeek()">{{week}}</v-flex>
                <v-flex xs1>
                  <v-icon
                    class="nextWeekArr icon-transform-1"
                    @click="nextWeek()"
                  >keyboard_arrow_right</v-icon>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- Date -->
          <v-layout class="font-number-2 text-xs-center">
            <v-flex
              style="cursor:cell!important"
              xs12
              sm2
              v-for="i in 7"
              :key="i"
              @click="addClassToWeek(days[i-1])"
            >{{checkDate(i)}}</v-flex>
          </v-layout>
          <!-- Day -->
          <v-layout class="font-heading text-xs-center">
            <v-flex xs12 sm2 v-for="i in 7" :key="i" @click="addClassToWeek(days[i-1])">
              <div style="cursor:cell!important" v-if="language == 'en'">{{daysEN[i-1]}}</div>
              <div style="cursor:cell!important" v-else-if="language == 'fi'">{{daysFI[i-1]}}</div>
              <div style="cursor:cell!important" v-else-if="language == 'sv'">{{daysSV[i-1]}}</div>
            </v-flex>
          </v-layout>
          <!-- Classes -->
          <v-layout>
            <v-flex xs2 v-for="i in 7" :key="i" v-bind:class="dayStyle(i)">
              <v-flex xs12 v-for="item in getDay(i-1)" :key="item.class" text-xs-center>
                <v-spacer>
                  <br>
                </v-spacer>
                <v-layout row wrap>
                  <v-layout row wrap>
                    <v-flex xs3 class="headline mt-1 ml-2 mr-2">{{item.time}}</v-flex>
                    <v-flex xs8>
                      <v-layout
                        row
                        wrap
                        class="text-xs-left"
                        v-bind:style="{'padding':'0px 0px 0px 3px'}"
                      >
                        <v-flex xs10>{{getVideoById(item.classId).name}}</v-flex>
                        <v-flex v-if="!addClassDesktop" xs2 text-xs-left>
                          <v-icon
                            class="deleteBtn red--text icon-transform-1"
                            @click="editScheduledClass({day: days[i-1], time: item.time, class: item.classId })"
                            :disabled="addClassDesktop"
                          >remove_circle</v-icon>
                        </v-flex>
                        <v-flex
                          xs12
                          class="font-subheading"
                        >{{getVideoById(item.classId).duration}} min</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-flex
                    class="classBar mx-2"
                    v-bind:style="{ 'background-color':getVideoById(item.classId).color}"
                  ></v-flex>
                  <v-spacer>
                    <br>
                  </v-spacer>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </section>

    <!-- Mobile -->
    <section v-else style="margin-top: 56px;">
      <v-layout row wrap class="mx-3">
        <!-- Date Picker -->
        <v-flex xs12 class="mt-3">
          <v-card class="mb-3">
            <v-card-title>
              <v-select
                max-height="400"
                :items="$store.getters.getDevices"
                item-text="name"
                item-value="item"
                v-model="selectedPlayer"
                @input="updateSelectedSchedule()"
                hide-details
                :label="selPlayerLang()"
                class="pr-3"
              ></v-select>
            </v-card-title>
          </v-card>
          <v-date-picker
            v-model="pickerVal"
            @input="pickerChangeWeek()"
            :locale="localeLang()"
            no-title
            style="width: 100%;"
          ></v-date-picker>
        </v-flex>
        <!-- Classes -->
        <v-flex xs12>
          <v-layout class="my-3" row wrap>
            <v-flex xs12 v-for="item in getPickerDay" :key="item.class" text-xs-center>
              <v-spacer>
                <br>
              </v-spacer>
              <v-layout row wrap>
                <v-flex xs3 class="headline mt-1 ml-2 mr-2">{{item.time}}</v-flex>
                <v-layout
                  row
                  wrap
                  class="text-xs-left"
                  v-bind:style="{'padding':'0px 0px 0px 3px'}"
                >
                  <v-flex xs10>{{getVideoById(item.classId).name}}</v-flex>
                  <v-flex xs2 class="pl-3">
                    <v-icon
                      class="deleteBtn red--text icon-transform-1"
                      @click="editScheduledClass({day: selectedDay, time: item.time, class: item.classId }), addMobile= true"
                    >remove_circle</v-icon>
                  </v-flex>
                  <v-flex xs12 class="font-subheading">{{getVideoById(item.classId).duration}} min</v-flex>
                </v-layout>
              </v-layout>
              <v-flex
                class="classBar"
                v-bind:style="{ 'background-color':getVideoById(item.classId).color}"
              ></v-flex>
              <v-spacer>
                <br>
              </v-spacer>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Add Class Btn -->
        <v-flex xs12 text-xs-center>
          <v-btn fab color="success" @click="addClassMobile = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </section>

    <!-- Edit Dialog Desktop -->
    <v-dialog v-model="enableDelClassDesk" persistent max-width="500">
      <v-card>
        <v-card-title>
          <v-layout row wrap justify-center>
            <v-flex xs12 text-xs-center class="my-5">
              <v-icon
                class="red--text"
                style="border-radius: 50px;  background: radial-gradient(white 50%, #f44336 0%); font-size: 75px;"
              >error</v-icon>
            </v-flex>
            <v-flex xs12 v-lang.confirmDel text-xs-center></v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions class="mt-0">
          <v-layout align-center justify-center class="mb-3">
            <v-btn
              v-lang.cancel
              color="primary"
              @click="enableDelClassDesk = false; editClass = false"
            ></v-btn>
            <v-btn
              v-lang.delete
              v-if="editClass"
              color="error"
              alert
              @click="removeClassFromWeek()"
            ></v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog Mobile -->
    <v-dialog v-model="addClassMobile" persistent max-width="500">
      <v-card>
        <v-card-title>
          <v-layout row wrap justify-center>
            <v-flex xs12>
              <v-select
                max-height="400"
                hide-details
                :label="selClassLang()"
                v-model="classToSchedule"
                :items="getAvailableClasses"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                max-height="400"
                hide-details
                :label="selHoursLang()"
                v-model="startHour"
                v-bind:items="hoursArray()"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                max-height="400"
                hide-details
                :label="selMinutesLang()"
                v-model="startMinute"
                v-bind:items="minutesArray()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions class="mt-0">
          <v-layout align-center justify-center>
            <v-btn round v-lang.accept color="success" @click="addClassToWeek(selectedDay)"></v-btn>
            <v-btn
              round
              v-lang.cancel
              color="primary"
              @click="addClassMobile = false; editClass = false"
            ></v-btn>
            <v-btn
              round
              v-lang.delete
              v-if="editClass"
              color="error"
              alert
              @click="removeClassFromWeek()"
            ></v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Footer -->
    <c-footer></c-footer>
  </v-content>
</template>

 <script>
var moment = require("moment");
import CFooter from "./Footer";
export default {
  data() {
    return {
      // x: 0,
      show: false,
      addMobile: false,
      addClassMobile: false,
      addClassDesktop: true,
      enableDelClassDesk: false,
      editClass: false,
      cursorStyle: "",
      selectedPlayer: null,
      date: "",
      daysEN: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      daysFI: ["ma", "ti", "ke", "to", "pe", "la", "su"],
      daysSV: ["må", "ti", "on", "to", "fr", "lö", "sö"],
      week: "",
      weekToCopy: 0,
      month: "",
      monthsEN: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      monthsFI: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kesäkuu",
        "heinäkuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
      ],
      monthsSV: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
      ],
      startHour: "00",
      startMinute: "00",
      startTime: "",
      classToSchedule: null,
      editableDay: "",
      selectedYear: "",
      pickerVal: "",
      selectedDay: "",
      days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]
    };
  },
  components: {
    CFooter
  },
  methods: {
    removeClassFromWeek() {
      let c = {
        classId: this.classToSchedule,
        time: this.startTime
      };
      this.$store.dispatch("removeClassFromWeek", {
        day: this.editableDay,
        class: c
      });
      this.enableDelClassDesk = false;
      this.editClass = false;
    },
    editScheduledClass(data) {
      this.editClass = true;
      //{day: selectedDay, time: item.time, class: item.class 13:30 }
      let t = data.time.split(":");
      this.startTime = data.time;
      this.startHour = t[0];
      this.startMinute = t[1];
      this.classToSchedule = data.class;
      // this.addClassMobile = true;
      this.enableDelClassDesk = true;
      this.editableDay = data.day;
    },
    updateWeek() {
      this.$store.dispatch("changeSelectedWeek", this.week);
    },
    updateYear() {
      this.$store.dispatch("changeSelectedYear", this.selectedYear);
    },
    copyWeek() {
      this.weekToCopy = this.week;
      this.$store.dispatch("setWeekToCopy", this.week);
      this.show = true;
    },
    pasteWeek() {
      this.$store.dispatch("copyFromWeekToWeek", this.weekToCopy);
    },
    saveSchedule() {
      this.addClassDesktop = true;
      this.enableDelClassDesk = false;
      this.$store.dispatch("saveSchedule");
    },
    addClassToWeek: function(day) {
      this.addClassMobile = false;
      if (this.editClass === true) {
        this.$store.dispatch("replaceClassInDay", {
          day: day,
          class: {
            classId: this.classToSchedule,
            time: this.startHour + ":" + this.startMinute
          }
        });
        this.editClass = false;
      } else {
        if (this.classToSchedule !== null) {
          this.$store.dispatch("addClassToWeek", {
            day: day,
            class: {
              classId: this.classToSchedule,
              time: this.startHour + ":" + this.startMinute
            }
          });
        }
      }
    },
    checkDate: function(i) {
      var x = moment()
        .set("year", this.selectedYear)
        .day("Monday")
        .week(this.week);
      return x.add(i - 1, "days").date();
    },

    dayStyle: function(i) {
      if (i > 5) {
        return "weekendBack dayBorderRight";
      } else if (i >= 2 && i < 6) {
        return "dayBorderRight";
      } else if (i < 2) {
        return "dayBorderLeft dayBorderRight";
      }
    },
    getDeviceById(id) {
      let n = this.$store.getters.getDevices.find(device => {
        return device.id == id;
      });
      // console.log("IIIIIIIIIID============>", id);
      // console.log("NNNNNNNNNNNNNNNNNNN =>>>>>>>", n);
      if (n != undefined) {
        return n.name;
      } else {
        return "a";
      }
    },
    /* getVideoById(id) {
      if (id != null) {
        return this.$store.getters.getVideos.find(video => {
          return video.id == id;
        });
      }
    }, */
    getVideoById(id) {
      if (id != null) {
        let x = this.$store.getters.getVideos.find(video => {
          return video.id == id;
        });
        if (x === undefined) {
          return {
            name: "No video found",
            duration: 0,
            color: "grey"
          };
        } else {
          return x;
        }
      }
    },
    getDay: function(day) {
      if (
        this.$store.getters.getSelectedWeek != null &&
        (this.$store.getters.getSelectedWeek[this.days[day]] != null ||
          this.$store.getters.getSelectedWeek[this.days[day]] != undefined)
      ) {
        return this.$store.getters.getSelectedWeek[this.days[day]];
      } else {
        return [];
      }
    },
    clearWeek() {
      this.$store.dispatch("clearWeek");
    },
    gotoCurrentWeek() {
      this.week = moment().isoWeek();
      this.$store.dispatch("changeSelectedWeek", this.week);
    },
    nextWeek() {
      let y = moment()
        .set("year", this.selectedYear)
        .isoWeeksInYear();
      if (this.week < y) {
        this.week += 1;
      } else {
        this.week = 1;
        this.selectedYear += 1;
      }
      this.$store.dispatch("changeSelectedWeek", this.week);
    },
    prevWeek() {
      let y = moment()
        .set("year", this.selectedYear)
        .isoWeeksInYear();
      if (this.week > 1) {
        this.week -= 1;
      } else {
        this.week = y;
        this.selectedYear -= 1;
      }
      this.$store.dispatch("changeSelectedWeek", this.week);
    },

    pickerChangeWeek() {
      this.selectedDay = moment(this.pickerVal, "YYYY-MM-DD")
        .format("ddd")
        .toLowerCase();
      this.week = moment(this.pickerVal, "YYYY-MM-DD").isoWeek();
      this.$store.dispatch("changeSelectedWeek", this.week);
    },

    minutesArray() {
      let x = [];
      for (let i = 0; i < 60; i += 5) {
        if (i < 10) {
          x.push("0" + i);
        } else {
          x.push(i.toString());
        }
      }
      return x;
    },
    hoursArray() {
      let x = [];
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          x.push("0" + i);
        } else {
          x.push(i.toString());
        }
      }
      return x;
    },
    weekArray() {
      let x = [];
      let y = moment()
        .set("year", this.selectedYear)
        .isoWeeksInYear();
      for (let i = 1; i <= y; i++) {
        x.push(i);
      }
      return x;
    },
    yearArray() {
      let x = [];
      x.push(moment().year() - 1);
      x.push(moment().year());
      x.push(moment().year() + 1);
      return x;
    },
    updateSelectedSchedule() {
      /* console.log(this.selectedPlayer.scheduleId); */
      this.$store.dispatch(
        "changeSelectedSchedule",
        this.selectedPlayer.scheduleId
      );
    },
    selClassLang() {
      if (this.language == "en") {
        return "Select Class";
      } else if (this.language == "fi") {
        return "Valitse ohjelma";
      } else {
        return "Välj klass";
      }
    },
    selHoursLang() {
      if (this.language == "en") {
        return "Select Hour";
      } else if (this.language == "fi") {
        return "Valitse tunti";
      } else {
        return "Välj timme";
      }
    },
    selMinutesLang() {
      if (this.language == "en") {
        return "Select Minutes";
      } else if (this.language == "fi") {
        return "Valitse minuutit";
      } else {
        return "Välj minuter";
      }
    },
    selPlayerLang() {
      if (this.language == "en") {
        return "Select Player";
      } else if (this.language == "fi") {
        return "Valitse laite";
      } else {
        return "Välj enhet";
      }
    },
    selYearLang() {
      if (this.language == "en") {
        return "Select Year";
      } else if (this.language == "fi") {
        return "Valitse vuosi";
      } else {
        return "Välj år";
      }
    },
    selWeekLang() {
      if (this.language == "en") {
        return "Select Week";
      } else if (this.language == "fi") {
        return "Valitse viikko";
      } else {
        return "Välj vecka";
      }
    },
    localeLang() {
      if (this.language == "en") {
        return "en-UK";
      } else if (this.language == "fi") {
        return "fi-fi";
      } else {
        return "sv-se";
      }
    }
  },
  computed: {
    getCursor() {
      return this.classToSchedule ? "cursor:cell" : "";
    },
    getAvailableClasses() {
      if (this.selectedPlayer !== null) {
        var filtered = this.$store.getters.getCategories.filter(cat => {
          return this.selectedPlayer.categories.find(c => {
            return cat.id == c;
          });
        });
        let videos = [];
        filtered.forEach(cat => {
          cat.videos.forEach(dd => {
            if (
              videos.findIndex(y => {
                return y == dd;
              }) == -1
            ) {
              videos.push(dd);
            }
          });
        });
        let t = [];
        this.$store.getters.getVideos
          .filter(el => {
            return videos.find(v => {
              return v == el.id;
            });
          })
          .forEach(element => {
            t.push({
              id: element.id,
              name: element.name
            });
          });
        return t.sort(function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      } else {
        return [];
      }
    },
    getCalendar: function() {
      return this.calendar.sort(function(a, b) {
        if (a.day < b.day) {
          return -1;
        }
        if (a.day > b.day) {
          return 1;
        }
        return 0;
      });
    },
    getMonth: function() {
      var x = moment()
        .day("Monday")
        .week(this.week);
      if (this.language == "en") {
        return this.monthsEN[x.month()];
      } else if (this.language == "fi") {
        return this.monthsFI[x.month()];
      } else {
        return this.monthsSV[x.month()];
      }
    },

    getPickerDay: function() {
      if (
        this.$store.getters.getSelectedWeek != null &&
        (this.$store.getters.getSelectedWeek[
          moment(this.pickerVal, "YYYY-MM-DD")
            .format("ddd")
            .toLowerCase()
        ] != null ||
          this.$store.getters.getSelectedWeek[
            moment(this.pickerVal, "YYYY-MM-DD")
              .format("ddd")
              .toLowerCase()
          ] != undefined)
      ) {
        return this.$store.getters.getSelectedWeek[
          moment(this.pickerVal, "YYYY-MM-DD")
            .format("ddd")
            .toLowerCase()
        ];
      } else {
        return [];
      }
    }
  },
  mounted() {
    this.week = moment().isoWeek();
    /* console.log("SA"); */
    this.pickerVal = moment().format("YYYY-MM-DD");
    this.selectedDay = moment(this.pickerVal, "YYYY-MM-DD")
      .format("ddd")
      .toLowerCase();
    this.$store.dispatch("changeSelectedWeek", this.week);
    this.selectedYear = moment().year();
    if (this.$store.getters.getSelectedScheduleId !== null) {
      this.selectedPlayer = this.$store.getters.getDevices.find(dev => {
        return dev.scheduleId == this.$store.getters.getSelectedScheduleId;
      });
    }
  }
};
</script>

<style>
.weekendBack {
  min-height: 400px;
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
}

.dayBorderRight {
  border-right: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.dayBorderLeft {
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.classBar {
  width: 100%;
  height: 8px;
  border-radius: 25px;
  background-color: red;
  box-shadow: 0px 3px 5px black;
}
.cell {
  cursor: cell;
}
.nextWeekArr {
  font-size: 1em;
}
.deleteBtn {
  border-radius: 50px;
  box-shadow: 0px 3px 5px black;
  background: radial-gradient(white 50%, #f44336 0%);
}
/* .editBtn {
  position: fixed;
  bottom: 44px;
  z-index: 2;
} */
</style>



// WEBPACK FOOTER //
// src/components/Schedules.vue